module.exports = __webpack_public_path__ + "static/media/hero_pricing_image.22dbcaab.png";